import { DislikeTwoTone, EditTwoTone, LikeTwoTone } from "@ant-design/icons";
import { Input, Space, Tooltip, Typography } from "antd";
import FlexContainerLayout from "components/atoms/FlexContainerLayout";
import { useState } from "react";

const { TextArea } = Input;
const { Text } = Typography;

/** @type {import('./types').NaturalLanguageQueryViewer} */
function NaturalLanguageQueryViewer({ naturalLanguageText, dslQuery, error, showQueryEditor, onClickQueryFeedback, onEditQuery }) {
    const [accuracy, setAccuracy] = useState(-1);

    const onClickAccuracy = (accuracy) => {
        setAccuracy(accuracy);
        onClickQueryFeedback && onClickQueryFeedback({ accuracy });
    };

    return (
        <FlexContainerLayout
            headerClassName="py-2 px-4"
            footerClassName="py-2 px-4"
            contentClassName="py-2 px-4"
            header={<Text strong={true}>{naturalLanguageText}</Text>}
            footer={
                <Space orientation={"horizontal"} style={{ paddingTop: "1rem" }} size="large">
                    <Tooltip title={"It's a flawless query"}>
                        <LikeTwoTone style={{ fontSize: "1.5rem" }} twoToneColor={accuracy === 100 ? "orange" : null} onClick={() => onClickAccuracy(100)} />
                    </Tooltip>
                    <Tooltip title={"It's an imperfect query"}>
                        <DislikeTwoTone style={{ fontSize: "1.5rem" }} twoToneColor={accuracy === 0 ? "orange" : null} onClick={() => onClickAccuracy(0)} />
                    </Tooltip>
                    {showQueryEditor && (
                        <Tooltip title={"Edit in Build My Query"}>
                            <EditTwoTone style={{ fontSize: "1.5rem" }} onClick={onEditQuery} />
                        </Tooltip>
                    )}
                </Space>
            }
        >
            {dslQuery && <TextArea readOnly={true} value={JSON.stringify(dslQuery, null, 2)} autoSize />}
            {error && <Text type="danger">{error}</Text>}
        </FlexContainerLayout>
    );
}

export default NaturalLanguageQueryViewer;
